
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M100 22c43.078 0 78 34.922 78 78s-34.922 78-78 78-78-34.922-78-78 34.922-78 78-78zm0 11a8 8 0 00-8 8v58.878c-.001.112 0 .225.002.337l.002.034a8.115 8.115 0 00.01.232 7.953 7.953 0 00.808 3.055l.037.075a7.351 7.351 0 00.126.239l.055.097a7.92 7.92 0 001.356 1.764l.053.05a7.58 7.58 0 00.864.723l.02.013 35.5 25.5.221.154a8 8 0 009.113-13.148L108 95.896V41l-.004-.25A8 8 0 00100 33z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    